// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { viewSelectStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListTableViewFilter";
import RefineFilters from "@guestsupply/XDL/Icons/RefineFilters";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import Filter from "@insite/mobius/Icons/Filter";
import Tag from "@insite/mobius/Tag";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        padding-top: 5px;
        ${xScreen("gt", "md")} {
            display: none;
        }
    `,
};
viewSelectStyles.filterClickable = {
    css: css`
        margin-right: 20px;
    `,
};
viewSelectStyles.filterIcon = {
    src: Filter,
    size: 30,
};
viewSelectStyles.tagIcon = {
    src: Tag,
    size: 30,
};
viewSelectStyles.filterDrawer = {
    position: "left",
    size: 360,
    closeButtonProps: {
        size: 14,
        css: css`
            padding: 8px;
        `,
    },
    cssOverrides: {
        drawerTitle: css`
            margin-bottom: 16px;
        `,
        drawerContent: css`
            padding: 0;
            height: 100%;
            overflow-x: hidden;
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            overflow-y: hidden;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        headlineTypography: css`
            font-weight: bold;
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
    },
};
// XNG-CHANGES
viewSelectStyles.filterLink = {
    icon: {
        iconProps: {
            src: RefineFilters,
            size: 16,
            color: "common.ui8",
        },
        position: "left",
    },
};
viewSelectStyles.clearAllFiltersOuterWrapper = {
    css: css`
        padding: 0 17px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: ${getColor("common.white")};
    `,
};
viewSelectStyles.clearAllFiltersInnerWrapper = {
    css: css`
        padding: 17px 0;
        border-top: 1px solid ${getColor("common.border")};
    `,
};
viewSelectStyles.clearAllFiltersButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
    `,
};
viewSelectStyles.filterDrawerContentWrapper = {
    css: css`
        margin-bottom: 68px;
    `,
};
